module.exports = __webpack_public_path__ + "static/media/img5.f2982fc6.jpg";